






















































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import Mixin from '@/mixin';
import { validationMixin } from 'vuelidate';
import messageModule from '@/store/modules/common/message.module';
import VMessage from '@/components/items/VMessage.vue';
import VPasswordInput from '@/components/items/VPasswordInput.vue';
import { minLength, required, sameAs } from 'vuelidate/lib/validators';
import coachService from '@/services/common/coach.service';
import managerService from '@/services/common/manager.service';

@Component({
  name: 'VPopupResetPassword',
  components: { VPasswordInput, VMessage },
  mixins: [validationMixin],
  validations: {
    password: { required, minLength: minLength(6) },
    passwordConfirmation: { required, samAsPassword: sameAs('password') }
  }
})
export default class VPopupResetPassword extends Mixin {
  @Prop({ required: false }) id?: number;
  @Prop({ required: false }) title?: string;
  @Prop({ required: false }) type?: 'manager' | 'coach' | 'coachClient';
  @Prop({ required: true }) isShowModal?: boolean;

  public password = '';
  public passwordConfirmation = '';
  public generated = '';
  public copied = false;

  // Clear the form whenever the modal is closed so a stale password/value
  // doesn't carry over to the next coach/manager/client.
  @Watch('isShowModal')
  onToggle(val?: boolean) {
    if (!val) {
      this.password = '';
      this.passwordConfirmation = '';
      this.generated = '';
      this.copied = false;
      this.$v?.$reset();
    }
  }

  public generate() {
    const pw = this.makeInitPassword(10);
    this.password = pw;
    this.passwordConfirmation = pw;
    this.generated = pw;
    this.copied = false;
    this.$v?.$touch();
  }

  public async copyGenerated() {
    if (!this.generated) return;
    try {
      await navigator.clipboard.writeText(this.generated);
    } catch (e) {
      const textarea = document.createElement('textarea');
      textarea.value = this.generated;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
    }
    this.copied = true;
    setTimeout(() => {
      this.copied = false;
    }, 2000);
  }

  get message() {
    return messageModule.message;
  }

  get messageType() {
    return messageModule.type;
  }

  get allowSubmit() {
    return !(this.$v?.$error || this.$v?.$invalid);
  }

  public async save() {
    this.$v?.$touch();
    if (this.allowSubmit && this.id) {
      if (this.type === 'coach') {
        await coachService.resetPassword(this.id, { password: this.password });
      } else if (this.type === 'coachClient') {
        await coachService.resetCoachClientPassword(this.id, {
          password: this.password
        });
      } else if (this.type == 'manager') {
        await managerService.resetPassword(this.id, {
          password: this.password
        });
      }
      this.$emit('hide');
    }
  }
}
